export const QUERY_PARAMETER = 'perf';

/**
 * The readout is a single text texture, so it is rasterized again on every refresh. Twice a second is frequent
 * enough to watch a navigation and cheap enough not to distort what it is measuring.
 */
export const REFRESH_INTERVAL_MS = 500;

/**
 * Frames slower than this are counted as dropped. 32ms is two missed frames at 60Hz, which is roughly where
 * navigation starts to feel like it is lagging behind the remote.
 */
export const DROPPED_FRAME_MS = 32;

/**
 * The strips are sampled more often than the readout is redrawn: a bar is a couple of property writes, while the
 * readout is a text texture that has to be rasterized again on every refresh.
 */
export const SAMPLE_INTERVAL_MS = 250;

/** Fixed top of the fps strip, so its height is comparable between runs */
export const TARGET_FPS = 60;

export const MEGA = 1e6;

/** Share of the texture budget past which the readout turns red */
export const TEXTURE_PRESSURE_ALERT = 90;

/**
 * Enabled with `?perf=true`, so it costs nothing in a normal run
 *
 * @returns {boolean} whether the monitor should be mounted
 */
export const isPerformanceMonitorEnabled = () => {
  try {
    return new URL(document.location).searchParams.get(QUERY_PARAMETER) === 'true';
  } catch (error) {
    return false;
  }
};
